import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    successDialog: {
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  successIcon: {
    fontSize: '64px',
    color: '#4caf50',
    marginBottom: theme.spacing(2),
  },
  errorIcon: {
    fontSize: '64px',
    color: '#f44336',
    marginBottom: theme.spacing(2),
  },
}));

const ErrorDialog = ({ open, onClose, message }) => {
    const classes = useStyles();
    return (
        <>
         {/* Dialogue d'erreur */}
                <Dialog
                  open={open}
                  onClose={onClose}
                  maxWidth="sm"
                  fullWidth
                >
                  <DialogTitle style={{ backgroundColor: '#f44336', color: 'white', textAlign: 'center' }}>
                    Erreur
                  </DialogTitle>
                  <DialogContent className={classes.successDialog}>
                    <ErrorIcon className={classes.errorIcon} />
                    <Typography variant="h6" style={{ marginBottom: '16px', color: '#c62828' }}>
                      Une erreur est survenue
                    </Typography>
                    <Typography variant="body2" style={{ marginBottom: '24px', color: '#666' }}>
                      {message}
                    </Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={onClose} color="primary" variant='outlined'>
                      Fermer
                    </Button>
                  </DialogActions>
                </Dialog> 
        </>

    );
}

export default ErrorDialog;